import { AgentLayout, loadAgentDetail } from "@/components/agents/agent-layout";
import { Navigate, createFileRoute, useLoaderData } from "@tanstack/react-router";

/**
 * `/agents/$slug` — the agent shell: header, figures, switches and the
 * tab strip. The loader fetches the detail once and every tab reads it
 * back with `useLoaderData({ from: "/_app/agents/$slug" })`, the way a
 * project's tabs read their overview.
 *
 * E2E behaviour contract lives in `e2e/analysis/agents.spec.ts`.
 */
export const Route = createFileRoute("/_app/agents/$slug")({
  loader: ({ params }) => loadAgentDetail(params.slug),
  component: AgentDetailLayout,
});

function AgentDetailLayout() {
  const { user } = useLoaderData({ from: "/_app" });
  const { slug } = Route.useParams();
  if (user.globalRole !== "admin") return <Navigate to="/" />;
  return <AgentLayout data={Route.useLoaderData()} slug={slug} />;
}
